module.exports = __webpack_public_path__ + "static/media/intro.56f385dd.glb";